import types from './types';

export const list =
  (list) => ({
    type: types.DR_SIDE_KOJI_COSTLIST,
    list,
  });

export const id =
  (id) => ({
    type: types.DR_SIDE_KOJI_COSTID,
    id,
  });

export const detail =
  (detail) => ({
    type: types.DR_SIDE_KOJI_COSTDETAIL,
    detail,
  });

export default {
  list,
  id,
  detail,
};
